import { Dialog } from "@mui/material";
import EarningsCalendar from "./earningsCalendar";

const EarningsDialog = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="lg"
    PaperProps={{
      sx: {
        bgcolor: "var(--color-bg-primary)",
        backgroundImage: "none",
        borderRadius: "var(--radius-lg)",
        border: "1px solid var(--color-border-primary)",
        m: 2,
        width: "calc(100% - 32px)",
        height: "85vh",
        maxHeight: "calc(100% - 32px)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      },
    }}
  >
    <EarningsCalendar variant="dialog" onClose={onClose} />
  </Dialog>
);

export default EarningsDialog;